export const NORMAL = 'NORMAL';
export const UNWANTED = 'UNWANTED';

const zoneTypes = {
	NORMAL,
	UNWANTED,
};

export default zoneTypes;